import axios from "axios";
import React from "react";
import { EXCLUSION_TYPES, HTTP_STATUSES, STANDARD_ERRORS_WAY } from "../../../../utils/consts";
import { getServiceNameWithNickname } from "../../../../utils/getServiceNameWithNickname";
import { parseAxiosError } from "../../../../utils/response";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import ExclusionValueUpdateForm from "../../../elements/ServiceExclusions/New/ExclusionValueUpdateForm";
import MaterialSwitch from "../../../styles/materialSwitch";
import { StyledCol, StyledTableRow } from "../../../styles/styledTable";
import { StyledExclusionSwitch } from "../../styledBinData";

const ServiceExclusionItem = ({ exclusion, t, notification, setNotification, setFetch }) => {

  const {
    name,
    service
  } = exclusion;

  const handleRemove = () => {
    axios.delete(`/api/service-exclusion-lists/${exclusion.id}`, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_NO_CONTENT) {
        setFetch(prevState => !prevState);
        setNotification({ ...notification, visible: true, type: "success", message: t("exclusions.successDelete") });
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  }

  const handleUpdate = (type) => {
    let data = {
      type: type
    };

    axios.put(`/api/service-exclusion-lists/${exclusion.id}`, data, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        exclusion.type = type;
        setNotification({ ...notification, visible: true, type: "success", message: t("exclusions.successEdit") });
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  return (
    <StyledTableRow
      scroll="auto"
      col="5"
      className="service-exclusion-table-new__row"
    >
      <StyledCol>
        {getServiceNameWithNickname(service.name, service.nickname)}
      </StyledCol>
      <StyledCol>
        {t(`exclusions.names.${name}`)}
      </StyledCol>
      <StyledCol>
        <ExclusionValueUpdateForm
          exclusion={exclusion}
          t={t}
          notification={notification}
          setNotification={setNotification}
          setFetch={setFetch}
        />
      </StyledCol>
      <StyledCol>
        <StyledExclusionSwitch>
          Whitelist
          <MaterialSwitch
            checked={exclusion.type === EXCLUSION_TYPES.blacklist}
            onChange={() => {
              handleUpdate(exclusion.type === EXCLUSION_TYPES.blacklist ? EXCLUSION_TYPES.whitelist : EXCLUSION_TYPES.blacklist);
            }}
          />
          Blacklist
        </StyledExclusionSwitch>
      </StyledCol>
      <StyledCol>
        <button
          className="table-action table-action_info"
          onClick={handleRemove}
        >
          <span className="icon-light-cancel" />
          {t("exclusions.editForm.delete")}
        </button>
      </StyledCol>
    </StyledTableRow>
  );
};

export default ServiceExclusionItem;